import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth"; // For web, default persistence (localStorage) is sufficient
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration - these are YOUR PUBLIC keys
// These are safe to include in your client-side code
const firebaseConfig = {
  apiKey: "AIzaSyAUzFXWPgFlLJv65NY7cAxXdP8HGtTZa7k",
  authDomain: "weso-mobile-app-b9e92.firebaseapp.com",
  projectId: "weso-mobile-app-b9e92",
  storageBucket: "weso-mobile-app-b9e92.firebasestorage.app",
  messagingSenderId: "450342522024",
  appId: "1:450342522024:web:d084ffb1a62003e8eec69d",
  // measurementId: "G-MP7KHYNP47", // Uncomment if you are using Firebase Analytics
};

// =========================================================
// Firebase Core App and Service Initializations (Client SDK)
// =========================================================

// Initialize Firebase App instance (safely for hot-reloading).
// This ensures 'initializeApp' is only called once.
export const FIREBASE_APP =
  getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

// Initialize Firebase Auth.
// On web, Firebase Auth maintains user sessions automatically using localStorage by default.
// No custom persistence or initializeAuth is required unless you specifically want session or none.
export const FIREBASE_AUTH = getAuth(FIREBASE_APP);

// Initialize Firebase Firestore instance.
export const FIRESTORE_DB = getFirestore(FIREBASE_APP);

// ===================================
// Third-Party Service Configurations
// ===================================

// For web, you typically export the webClientId to be used when instantiating
// GoogleAuthProvider in your authentication service functions (e.g., auth.js).
// The configureGoogleSignin function from React Native is not applicable here.
export const FIREBASE_WEB_CLIENT_ID =
  "450342522024-g7moul5l8q425bo3qbf0giu73fqdf9ak.apps.googleusercontent.com";

// The enable/disable logic and the configureGoogleSignin function itself are removed,
// as Google Sign-in for web is handled differently (via signInWithPopup/Redirect).
// You'd integrate GoogleAuthProvider in your auth.js like this:
/*
// Example from auth.js to use the web client ID
import { GoogleAuthProvider } from "firebase/auth";
import { FIREBASE_AUTH, FIREBASE_WEB_CLIENT_ID } from './config'; // Adjust path

export const googleSignin = async () => {
  const provider = new GoogleAuthProvider();
  // If you need to restrict domains or enable other features specific to your web client ID,
  // you might set those on the provider. For many basic setups, the default is fine.
  // provider.addScope('profile');
  // provider.addScope('email');
  // provider.setCustomParameters({
  //   'login_hint': 'user@example.com'
  // });

  // No need to explicitly pass the webClientId to the provider unless you're doing something unusual.
  // Firebase usually picks this up from your app configuration already.

  return signInWithPopup(FIREBASE_AUTH, provider);
};
*/

// Vertex AI/Gemini integration (kept as-is as it's not platform-specific for Firebase JS SDK)
/*
import { getVertexAI, getGenerativeModel } from "@firebase/vertexai";

// Initialize the Vertex AI service
const vertexAI = getVertexAI(FIREBASE_APP);

// Initialize the generative model with a model that supports your use case
// Gemini 1.5 models are versatile and can be used with all API capabilities
const model = getGenerativeModel(vertexAI, { model: "gemini-1.5-flash" });

// Wrap in an async function so you can use await
async function run() {
  // Provide a prompt that contains text
  const prompt = "Write a story about the Corporate Events industry.";

  // To generate text output, call generateContent with the text input
  const result = await model.generateContent(prompt);

  const response = result.response;
  const text = response.text();
  console.log(text);
}

run();
*/
